import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { SUBDOMAIN_HEADER } from '@/constants';
import { clientInstance } from '@/query/client-instance';
import { INTERNAL_CONFIGS_ENDPOINT } from '@/query/internal-endpoints';
import { CONFIGS_QUERY_KEY } from '@/query/query-keys';

export const useQueryConfigs = (options?: Omit<UseQueryOptions<Config>, 'queryKey'>) => {
  const params = useParams();
  return useQuery<Config>({
    queryKey: [CONFIGS_QUERY_KEY, params.subdomain],
    queryFn: async () =>
      (
        await clientInstance.get<Config>(INTERNAL_CONFIGS_ENDPOINT, {
          headers: {
            [SUBDOMAIN_HEADER]: params.subdomain
          }
        })
      ).data,
    staleTime: 60000, // 1 minute — limits stale updatedAt window while reducing refetches
    enabled: !!params.subdomain,
    ...options
  });
};
